import angular from 'angular';
import uiRouter from 'angular-ui-router';
import logoutComponent from './logout.component';

let logoutModule = angular.module('logout', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('logout', {
      url: '/logout',
      template: '<logout></logout>',
      authenticate: true
    })
})

.component('logout', logoutComponent);

export default logoutModule;



// WEBPACK FOOTER //
// ./client/app/components/logout/logout.js